/* eslint-disable react/prop-types */
import React from 'react';
import { AlertCircle, Award, Clock3, ClipboardList, Layers3 } from 'lucide-react';
import DialogModal from '../../../components/modal/DialogModal';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const getSectionQuestionCount = (section) => (
  toNumber(section?.questionperattempt)
  || toNumber(section?.total_questions)
  || toNumber(section?.questions_count)
  || toNumber(section?.question_count)
  || (Array.isArray(section?.questions) ? section.questions.length : 0)
  || (Array.isArray(section?.question_ids) ? section.question_ids.length : 0)
  || 0
);

const getSectionMarks = (section,assessment) => {  
  
  return assessment?.positive_marks * section.questionperattempt
  
  // if (toNumber(section?.total_marks) > 0) return toNumber(section.total_marks);
  // if (toNumber(section?.marks) > 0) return toNumber(section.marks);
  // if (Array.isArray(section?.questions)) {
  //   return section.questions.reduce((sum, question) => sum + (Number(question?.points) || 0), 0);
  // }
  // // In this API shape, marks per question are not provided; use question count as fallback.
  // if (toNumber(section?.questionperattempt) > 0) return toNumber(section.questionperattempt);
  // return 0;
};

const ViewAssessmentModal = ({ open, onClose, assessment, loading }) => {
  

  
  let sections = [];
  let variants = [];

  if (Array.isArray(assessment?.section_details)) {
    sections = assessment.section_details;
  }


  if (Array.isArray(assessment?.variant_modules)) {
    variants = assessment.variant_modules;
  }
  const allBlocks = [...sections, ...variants];
  

  const totalQuestions = allBlocks.reduce(
    (sum, item) => sum + getSectionQuestionCount(item),
    0
  );

  const totalMarks = allBlocks.reduce(
    (sum, item) => sum + getSectionMarks(item,assessment),
    0
  );

  const totalMinutes =
    // toNumber(assessment?.time_in_mins) ||
    // toNumber(assessment?.duration) ||
    allBlocks.reduce((sum, item) => sum + toNumber(item?.time), 0);

  return (
    <DialogModal
      open={open}
      handleClose={onClose}
      title={assessment?.title || 'Assessment'}
      maxWidth="lg"
      showCloseIcon
    >
      {loading ? (
        <div id="assessment-loading-state" className="flex justify-center items-center py-12">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-indigo-600 mb-3" />
            <p className="text-sm text-gray-600">Loading assessment details...</p>
          </div>
        </div>
      ) : (
        <div id="assessment-preview-container" className="rounded-2xl border border-indigo-200 bg-indigo-50/60 p-5 space-y-4">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-2">
              <Layers3 size={20} className="text-violet-600" />
              <h3 className="text-3xl font-semibold text-slate-900">Assessment Preview</h3>
            </div>
            <div className="flex flex-wrap items-center gap-4 text-slate-600">
              <div className="inline-flex items-center gap-1.5 text-2xl">
                <ClipboardList size={16} />
                <span id="assessment-total-questions">{totalQuestions} questions</span>
              </div>
              {assessment?.assessment_pattern_name === "Linear" &&
              <div className="inline-flex items-center gap-1.5 text-2xl">
                <Award size={16} />
                <span id="assessment-total-marks">{totalMarks} marks</span>
              </div>}
              <div className="inline-flex items-center gap-1.5 text-2xl">
                <Clock3 size={16} />
                <span id="assessment-total-minutes">{totalMinutes} min</span>
              </div>
            </div>
          </div>

          {sections.length === 0 ? (
            <div id="sections-empty-state" className="rounded-xl border-2 border-dashed border-slate-200 bg-white/70 min-h-[170px] flex items-center justify-center">
              <div className="text-center">
                <AlertCircle size={34} className="mx-auto text-slate-400 mb-2" />
                <p className="text-slate-500">No sections added yet</p>
              </div>
            </div>
          ) : (
            <div className="space-y-3">
              {sections.map((section, index) => (
                <div key={section?.id || index} id={`section-item-${index}`} className="rounded-xl border border-indigo-100 bg-white px-4 py-3">
                  <div className="flex items-center justify-between gap-3">
                    <p className="font-medium text-slate-900">{section?.title || section?.name || `Section ${index + 1}`}</p>
                    <div className="flex items-center gap-3 text-xs text-slate-500">
                      <span>{getSectionQuestionCount(section)} questions</span>
                      {assessment?.assessment_pattern_name === "Linear" &&
                      <span>{getSectionMarks(section,assessment)} marks</span>}
                      {toNumber(section?.time) > 0 && <span>{toNumber(section.time)} min</span>}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {assessment?.assessment_pattern_name !== "Linear" &&
            <>
              {variants?.length === 0 ? (
                <div id="variants-empty-state" className="rounded-xl border-2 border-dashed border-slate-200 bg-white/70 min-h-[170px] flex items-center justify-center">
                  <div className="text-center">
                    <AlertCircle size={34} className="mx-auto text-slate-400 mb-2" />
                    <p className="text-slate-500">No Variants added yet</p>
                  </div>
                </div>
              ) : (
                <div className="space-y-3">
                  {variants && variants?.map((section, index) => (
                    <div key={section?.id || index} id={`variant-item-${index}`} className="rounded-xl border border-indigo-100 bg-white px-4 py-3">
                      <div className="flex items-center justify-between gap-3">
                        <p className="font-medium text-slate-900">{section?.title || section?.name || `Section ${index + 1}`}</p>
                        <div className="flex items-center gap-3 text-xs text-slate-500">
                          <span>{getSectionQuestionCount(section)} questions</span>
                          {assessment?.assessment_pattern_name === "Linear" &&
                          <span>{getSectionMarks(section,assessment)} marks</span>}
                          {toNumber(section?.time) > 0 && <span>{toNumber(section.time)} min</span>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          }

          {assessment?.assessment_pattern_name && assessment?.break_details &&
            <div className="space-y-3">
              <div className="rounded-xl border border-indigo-100 bg-white px-4 py-3" id="assessment-break-details">
                <p className="font-medium text-slate-900">Break Page</p>
                <div className="mt-2 text-xs text-slate-500 space-y-1">
                  <p>{assessment?.break_details?.title}</p>
                  <p>{assessment?.break_details?.message}</p>
                </div>

              </div>
            </div>
          }

        </div>
      )}
    </DialogModal>
  );
};

export default ViewAssessmentModal;
